import { useState } from 'react'

export const useChipContent = ({
  firstChip,
  onFilter,
}: {
  firstChip: string
  onFilter: (selectedOption: string) => void
}) => {
  const [selectedChip, setSelectedChip] = useState(firstChip)

  return {
    content: {
      selectedChip,
      onClick: (option: string) => {
        setSelectedChip(option)
        onFilter(option)
      },
    },
  }
}
